exports = module.exports = require("../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "* {\r\n\tbox-sizing: border-box;\r\n\tmargin: 0px;\r\n\tpadding: 0px;\r\n\tfont-weight: normal;\r\n}\r\n\r\nhtml, body {\r\n\tpadding: 0px;\r\n\tmargin: 0px;\r\n\tfont-family: Arial;\r\n\tfont-size: 13px;\r\n\tcolor: #444;\r\n\tbackground-color: #FEFEFE;\r\n\t-moz-user-select: none;\r\n\t-webkit-user-select: none;\r\n\t-ms-user-select: none;\r\n\tcursor: default;\r\n}\r\n\r\nh1, h2 {\r\n\tcolor: #666;\r\n}\r\n\r\nimg {\r\n\tuser-drag: none;\r\n\t-moz-user-select: none;\r\n\t-webkit-user-drag: none;\r\n}\r\n\r\n.Hidden{\r\n\tdisplay: none !important;\r\n}\r\n\r\n.Invisible{\r\n\tvisibility: hidden !important;\r\n}\r\n\r\nbutton::-moz-focus-inner, input::-moz-focus-inner { \r\n\tborder: 0 !important;\r\n\tpadding: 0 !important;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/vwa/reset.css
// module id = 706
// module chunks = 0